import React from 'react';

interface CustomSupportCTAProps {
  text: string;
  buttonText: string;
}

const CustomSupportCTA: React.FC<CustomSupportCTAProps> = ({ text, buttonText }) => {
  return (
    <div className="text-center">
      <p className="text-gray-600 mb-4">{text}</p>
      <button 
        onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
        className="text-blue-600 font-semibold hover:text-blue-700 transition-colors"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default CustomSupportCTA;